export default __webpack_public_path__ + "static/media/oxxo.02a90f93.svg";